import { DOCUMENT_DOWNLOAD_MAX_SIZE_MB } from '@/shared/constants';

import { DELETE } from '@/front/fetch';
import { alertModal, confirmModal } from '@/front/modal';
import { setupTempAttachments } from '@/front/utils/attachments';

const EMPTY_DOCUMENTS_ROW_HTML = '<tr><td class="text-more-muted" colspan="3">No documents uploaded</td></tr>';

document.addEventListener('DOMContentLoaded', () => {
  initDocumentsUploadForm();
  initClientDocumentsCard();
});

const initDocumentsUploadForm = () => {
  const wrapper = document.querySelector('[data-documents-upload-form="true"]') as HTMLElement | null;

  if (!wrapper) return;

  const tempUrl = wrapper.dataset.documentsTempUrl;
  const input = document.getElementById('attachmentsJsonInput') as HTMLInputElement | null;
  const list = document.getElementById('attachmentsFilesList');
  const fileInput = document.getElementById('attachmentsFileInput') as HTMLInputElement | null;
  const uploadButton = document.getElementById('documentsUploadButton') as HTMLAnchorElement | null;

  if (!tempUrl || !input || !list || !fileInput || !uploadButton) return;

  const manager = setupTempAttachments({
    fileInput,
    list,
    maxSizeMb: DOCUMENT_DOWNLOAD_MAX_SIZE_MB,
    tempUrl,
    onError: alertModal,
    onChange: (items) => {
      input.value = JSON.stringify(items);
      uploadButton.dataset.disabled = items.length ? 'false' : 'true';
    },
  });

  uploadButton.addEventListener('click', (e) => {
    if (manager.getItems().length === 0) {
      e.preventDefault();
      alertModal('Please add at least one file.');
    }
  });
};

const initClientDocumentsCard = () => {
  document.querySelectorAll('[data-documents-card="true"]').forEach((card) => {
    card.querySelectorAll<HTMLAnchorElement>('[data-delete-attachment]').forEach((link) => {
      link.addEventListener('click', async (e) => {
        e.preventDefault();

        const deleteUrl = link.dataset.deleteAttachment;

        if (!deleteUrl) return;

        if (!(await confirmModal('Are you sure you want to delete this document?', 'Delete', 'danger'))) {
          return;
        }

        const res = await DELETE(deleteUrl);

        if (!res.ok) return;

        const tbody = card.querySelector('tbody');

        link.closest('tr')?.remove();

        if (tbody && !tbody.querySelector('[data-attachment-row="true"]')) {
          tbody.innerHTML = EMPTY_DOCUMENTS_ROW_HTML;
        }
      });
    });
  });
};
